import type {Timestamp} from 'firebase/firestore'

// Granted by admins, either to a whole organization or to one instructor within it.
export interface Subscription {
  plan?: 'free' | 'standard' | 'premium';
  max_courses?: number | null;
  max_students?: number | null;
  valid_until?: Timestamp | null;
}

export interface Organization {
  name: string;
  admin: string;
  domain?: string;
  subscription?: Subscription | null;
}

export interface OrganizationInstructor {
  name?: string;
  email?: string;
  subscription?: Subscription | null;
}

export function isActiveSubscription(subscription: Subscription | null | undefined, now = new Date()) {
  if (subscription == null) {
    return false
  }
  return subscription.valid_until == null || now < subscription.valid_until.toDate()
}

